import CallToAction from '@/components/layouts/CallToAction';
import FeatureSlider from '@/components/layouts/FeatureSlider';
import ImageTextBand from '@/components/layouts/ImageTextBand';
import Stats from '@/components/layouts/Stats';
import TextContent from '@/components/layouts/TextContent';
import Event from '@/components/templates/Event';
import Home from '@/components/templates/Home';
import Listing from '@/components/templates/Listing';
import Page from '@/components/templates/Page';
import Project from '@/components/templates/Project';
import StaffLayout from '@/components/templates/Staff';
import StoryPost from '@/components/templates/StoryPost';

import JobPositions from '../elements/JobPositions';
import ServiceMegaMenu from '../elements/ServiceMegaMenu';
import Benefits from '../layouts/Benefits';
import Compensation from '../layouts/Compensation';
import Contact from '../layouts/Contact';
import FeaturesIconLeft from '../layouts/FeaturesIconLeft';
import GalleryGrid from '../layouts/GalleryGrid';
import IconFeature from '../layouts/IconFeature';
import Images from '../layouts/Images';
import Logos from '../layouts/Logos';
import MaskedImage from '../layouts/MaskedImage';
import Paths from '../layouts/Paths';
import Process from '../layouts/Process';
import ProjectSlider from '../layouts/ProjectSlider';
import RemoveSpacing from '../layouts/RemoveSpacing';
import Staff from '../layouts/Staff';
import StandardTextLayout from '../layouts/StandardTextLayout';
import TimelineSection from '../layouts/Timeline';
import TwoColumnRichText from '../layouts/TwoColumnRichText';
import TwoColumnSwap from '../layouts/TwoColumnSwap';
import Bio from '../templates/Bio';

const StoryblokComponents = {
  home: Home,
  page: Page,
  bio: Bio,
  project: Project,
  listing: Listing,
  events: Event,
  spotlightListing: StaffLayout,
  storyPost: StoryPost,
  layoutCallToAction: CallToAction,
  layoutTextContent: TextContent,
  layoutImageTextBand: ImageTextBand,
  layoutStats: Stats,
  layoutFeatureSlider: FeatureSlider,
  layoutFeaturedProjects: ProjectSlider,
  layoutFeaturesIconLeft: FeaturesIconLeft,
  layoutTwoColumnRichText: TwoColumnRichText,
  layoutIconFeature: IconFeature,
  layoutGalleryGrid: GalleryGrid,
  layoutLogos: Logos,
  layoutMaskedImage: MaskedImage,
  layoutProcess: Process,
  layoutStaff: Staff,
  layoutPaths: Paths,
  layoutTwoColumnSwap: TwoColumnSwap,
  layoutStandardText: StandardTextLayout,
  layoutBenefits: Benefits,
  layoutCompensation: Compensation,
  layoutContact: Contact,
  layoutImages: Images,
  layoutRemoveSpacing: RemoveSpacing,
  serviceMegaMenu: ServiceMegaMenu,
  layoutOpenPositions: JobPositions,
  layoutTimeline: TimelineSection,
};

export default StoryblokComponents;
